<template>
  <div>
    <c-search-box ref="searchbox" @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-dept-multi
            v-if="popupParam.isMultiDept"
            label="관리부서"
            :parentCheckDepts="searchParam.multiDeptCd"
            name="multiDeptCd"
            v-model="searchParam.multiDeptCd"
          />
          <c-dept
            v-else
            type="search"
            label="관리부서"
            name="deptCd"
            v-model="searchParam.deptCd">
          </c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            v-if="popupParam.isAll"
            :comboItems="comboItems"
            type="none"
            itemText="codeName"
            itemValue="code"
            label="제조공정/작업절차 선택"
            name="processLevelCd"
            v-model="searchParam.processLevelCd">
          </c-select>
        </div>
      </template>
    </c-search-box>
    <!-- 공정 목록 -->
    <c-table
      ref="processTable"
      title="공정 목록"
      :columns="grid.columns"
      :data="grid.data"
      :gridHeight="grid.height"
      :selection="popupParam.type"
      :columnSetting="false"
      :isExcelDown="false"
      :isExpan="false"
      :isFullScreen="false"
      :rowKey="rowKey"
      @rowDblclick="rowDblclick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn label="LBLSELECT" icon="check" @btnClicked="select" />
          <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'process-pop',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        type: 'multiple',
        isAll: false,
        isMultiDept: false,
        multiDeptCd: '',
        processLevelCd: '20',
        plantCd: '',
        deptCd: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      rowKey: 'processCd',
      listUrl: '',
      grid: {
        columns: [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
          },
          {
            name: 'managementDeptsName',
            field: 'managementDeptsName',
            label: '부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'upProcessName',
            field: 'upProcessName',
            // 상위공정
            label: 'LBL0001700',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            // 단위공정
            label: 'LBL0001701',
            align: 'left',
            sortable: true
          },
        ],
        data: [],
        height: '600px'
      },
      searchParam: {
        plantCd: null,
        processName: '',
        multiDeptCd: '',
        processLevelCd: '20',
        multiDeptCdArray: [],
        useFlag: 'Y',
      },
      editable: true,
      searchUrl: '',
      comboItems:[
        {code: '10', codeName: '제조공정'},
        {code: '20', codeName: '작업절차'},
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - this.$refs['searchbox'].$el.offsetHeight - 100);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    }
  },
  methods: {
    init() {
      
      if (this.popupParam.plantCd) {
        this.searchParam.plantCd = this.popupParam.plantCd
      }
      if (this.popupParam.deptCd) {
        this.searchParam.deptCd = this.popupParam.deptCd
      }
      if (this.popupParam.processLevelCd) {
        this.searchParam.processLevelCd = this.popupParam.processLevelCd
      }
      if (this.popupParam.multiDeptCd) {
        this.searchParam.multiDeptCd = this.popupParam.multiDeptCd
      }
      this.listUrl = selectConfig.mdm.process.list.url;
      this.getList();
    },
    getList() {
      if (this.searchParam.multiDeptCd) {
        this.searchParam.multiDeptCdArray = this.searchParam.multiDeptCd.split(',')
      } else {
        this.searchParam.multiDeptCdArray = []
      }
      if (this.searchParam.processLevelCd == '10') {
        this.rowKey = 'processCd';
        this.grid.columns = [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
          },
          {
            name: 'managementDeptsName',
            field: 'managementDeptsName',
            label: '부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            label: '제조공정',
            align: 'left',
            sortable: true,
          },
        ];
      } else {
        this.rowKey = 'processCd';
        this.grid.columns = [
          {
            name: 'plantName',
            field: 'plantName',
            label: 'LBLPLANT',
            align: 'center',
            sortable: true,
          },
          {
            name: 'managementDeptsName',
            field: 'managementDeptsName',
            label: '부서',
            align: 'center',
            sortable: true,
          },
          {
            name: 'upProcessName',
            field: 'upProcessName',
            label: '제조공정',
            align: 'center',
            sortable: true,
          },
          {
            name: 'processName',
            field: 'processName',
            label: '공정절차(작업절차)',
            align: 'left',
            sortable: true
          },
        ];
      }
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';

      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    select() {
      let selectData = this.$refs['processTable'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: 'LBLGUIDE', // 안내
          message: 'MSGNOITEMS', // 선택된 항목이 없습니다.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.$emit('closePopup', selectData);
      }
    },
    rowDblclick(row) {
      if (this.popupParam.type === 'single') {
        this.$emit('closePopup', [row]);
      }
    },
  }
};
</script>
